/**
 * ScrollToTop — snaps the window back to the top on every route change.
 *
 * React Router keeps the scroll position when you navigate between pages,
 * so without this a click that opens a new page can leave you scrolled
 * halfway down. Drop it just inside <BrowserRouter> and every navigation
 * starts at the top.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
}
